import { N11BreadcrumbOneLevelPageItem } from './N11BreadcrumbOneLevel.types';

export function GetBreadcrumbTitle(pageItem?: N11BreadcrumbOneLevelPageItem): string {
  return pageItem?.navigationTitle?.value || pageItem?.name || '';
}
